// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w2OP","content":"styles_content__IRX1y"};